import { Link } from "react-router-dom";

interface Crumb {
  label: string;
  path?: string;
}

interface BreadcrumbProps {
  items: Crumb[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航">
      <ol className="flex flex-wrap items-center gap-1.5 text-sm text-foreground-600">
        <li>
          <Link to="/" className="whitespace-nowrap hover:text-primary-600 transition-colors">
            首页
          </Link>
        </li>
        {items.map((item, index) => (
          <li key={index} className="flex items-center gap-1.5">
            <i className="ri-arrow-right-s-line text-foreground-300"></i>
            {item.path ? (
              <Link to={item.path} className="whitespace-nowrap hover:text-primary-600 transition-colors">
                {item.label}
              </Link>
            ) : (
              <span className="whitespace-nowrap text-foreground-950 font-medium">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}